import { Control, FieldErrors } from 'react-hook-form';

export enum InputTypes {
  TEXT_AREA = 'textArea',
  INPUT = 'input',
  INPUT_GROUP = 'input-group',
}

export type dynamicInputType = {
  type: InputTypes;
  name: string;
  label: string;
  inputGroup?: dynamicInputType[];
  control?: Control<any>;
  errors?: FieldErrors<any>;
  classNames?: {
    wrapper?: string;
  };
};
